module.exports = __webpack_public_path__ + "static/media/modelC_cmp3.3b701211.gif";